import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Fourzerobusonrent() {



  const cardData =
  {
    keyword: '40 Seater Bus On Rent in Mumbai',
    heading: 'Sanavi Travels: 40 Seater Bus On Rent in Mumbai',
    headingDescription: 'Sanavi Travels offers reliable 40 Seater Bus On Rent in Mumbai, providing safe, comfortable, and spacious transportation for large groups, corporate trips, school excursions, family outings, and outstation travel from Mumbai. Our fleet of well-maintained AC and non-AC 40-seater buses ensures ample seating, smooth rides, and a hassle-free journey for all passengers. With professional drivers, flexible full-day and outstation rental packages, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free service. We provide convenient pickup and drop services across Mumbai including Andheri, Bandra, Borivali, Dadar, Navi Mumbai, Thane, and Mumbai Airport, making us a trusted choice for group transportation. Choose Sanavi Travels for trusted 40 seater bus rental services in Mumbai, delivering comfort, safety, and a seamless travel experience for every occasion.',

    top: 'Top Places to Visit in Mumbai with Sanavi Travels',


"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India is Mumbai’s most iconic landmark, overlooking the Arabian Sea. Built in 1924 to commemorate the visit of King George V and Queen Mary, it now serves as a bustling tourist hub and a starting point for ferries to Elephanta Caves."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, known as the 'Queen’s Necklace,' is a scenic seaside promenade along the Arabian Sea. Famous for its sunsets and evening walks, it offers sparkling views of city lights at night, making it a favorite spot for both locals and tourists."
  },
  {
    "title": "Elephanta Caves",
    "description": "Elephanta Caves are UNESCO World Heritage rock-cut caves on Elephanta Island, dedicated to Lord Shiva. The site features impressive sculptures, including the iconic Trimurti, reflecting ancient Indian art and architecture."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus",
    "description": "Chhatrapati Shivaji Maharaj Terminus is a historic railway station and UNESCO World Heritage Site, blending Victorian Gothic and Indian architectural styles. It stands as a symbol of Mumbai’s colonial past and urban vibrancy."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most popular beaches, known for its lively atmosphere, local street food, and sunset views. Visitors enjoy snacks like pav bhaji and bhel puri while relaxing by the sea."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple is a revered Hindu temple dedicated to Lord Ganesha. It attracts devotees from all over India, especially on Tuesdays and during festivals, for blessings of success and prosperity."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah is a famous mosque and tomb situated on a small islet in the Arabian Sea. Accessible via a narrow causeway, it draws visitors for its spiritual ambiance and stunning sea views."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park is a green oasis in Mumbai, featuring forests, wildlife, and the ancient Kanheri Caves. It offers trekking, safari tours, and nature walks, providing a refreshing escape from the city."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra-Worli Sea Link is a modern engineering marvel connecting Bandra and Worli. It offers spectacular views of the city skyline and the Arabian Sea, especially at night, making it a popular sightseeing spot."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is a vibrant shopping street in South Mumbai, famous for fashion, handicrafts, and street food. It is a hotspot for tourists seeking local shopping, dining, and cultural experiences."
  }
]
,



"services": [
  {
    "name": "40 Seater Bus On Rent in Mumbai",
    "description": "40 Seater Bus On Rent in Mumbai provides spacious, comfortable, and reliable transport for medium to large groups, perfect for family trips, corporate travel, weddings, school excursions, and tourist outings. Fully air-conditioned with reclining seats, wide legroom, and ample luggage space, these buses ensure a smooth and relaxing journey. Experienced chauffeurs manage traffic, routes, and schedules, guaranteeing safe and punctual travel. Flexible pickup, drop-off, and multi-stop itineraries make this service ideal for city travel, day trips, weekend getaways, and outstation trips from Mumbai."
  },
  {
    "name": "40 Seater Bus Hire Mumbai",
    "description": "40 Seater Bus Hire Mumbai offers organized and dependable rental services for group travel, including family outings, corporate events, weddings, school tours, and sightseeing trips. Fully air-conditioned buses with comfortable seating and ample luggage space provide a stress-free travel experience. Professional chauffeurs ensure safe, smooth, and timely journeys. Flexible itineraries and multiple stops make this service ideal for day trips, weekend getaways, and long-distance travel from Mumbai."
  },
  {
    "name": "AC 40 Seater Bus Mumbai",
    "description": "AC 40 Seater Bus Mumbai ensures a cool and comfortable ride for medium to large groups, featuring fully air-conditioned interiors, spacious seats, and wide legroom. Perfect for corporate travel, family trips, school excursions, weddings, and leisure tours, this service emphasizes comfort, safety, and convenience. Experienced chauffeurs handle navigation, traffic, and schedules, allowing passengers to relax throughout the journey with flexible pickup, drop-off, and route options."
  },
  {
    "name": "Luxury 40 Seater Bus Mumbai",
    "description": "Luxury 40 Seater Bus Mumbai provides a premium travel experience with stylish interiors, air-conditioning, comfortable reclining seats, and modern amenities. Ideal for VIP transport, corporate trips, weddings, and exclusive group tours, this service combines elegance, comfort, and punctuality. Professional chauffeurs manage traffic, routes, and schedules efficiently to ensure a smooth and safe journey. Customizable itineraries and flexible pickup and drop-off points make it suitable for city and outstation travel from Mumbai."
  },
  {
    "name": "Wedding 40 Seater Bus Mumbai",
    "description": "Wedding 40 Seater Bus Mumbai specializes in transporting wedding guests safely and comfortably. Fully air-conditioned with spacious seating and luggage space, these buses provide a stress-free travel experience for weddings, receptions, and related ceremonies. Professional chauffeurs ensure punctual arrivals, smooth driving, and coordinated multi-stop travel for family weddings, destination weddings, and large celebrations from Mumbai."
  },
  {
    "name": "Corporate 40 Seater Bus Mumbai",
    "description": "Corporate 40 Seater Bus Mumbai provides reliable transportation for business groups, corporate events, employee transfers, conferences, and corporate tours. Fully air-conditioned with comfortable seating and ample luggage space, these buses offer a safe and stress-free journey. Experienced chauffeurs manage routes, traffic, and schedules efficiently. Flexible scheduling, multi-stop trips, and convenient pickup and drop-off locations make it ideal for short or long-distance corporate travel from Mumbai."
  },
  {
    "name": "Outstation 40 Seater Bus Mumbai",
    "description": "Outstation 40 Seater Bus Mumbai is designed for long-distance travel for medium to large groups. Fully air-conditioned and spacious with reclining seats and luggage storage, these buses provide a comfortable ride for family trips, corporate tours, school excursions, and tourist journeys. Professional drivers manage highways, traffic, and route planning, ensuring safe and timely arrivals. Flexible itineraries with multiple stops allow smooth travel outside Mumbai."
  },
  {
    "name": "Affordable 40 Seater Bus Mumbai",
    "description": "Affordable 40 Seater Bus Mumbai offers cost-effective travel for family trips, corporate outings, school tours, weddings, and group excursions without compromising comfort or safety. Fully air-conditioned with spacious seating and luggage space, these buses provide a smooth and reliable travel experience. Experienced chauffeurs manage navigation, traffic, and timing efficiently. Flexible pickup, drop-off, and customizable routes make it ideal for day trips, weekend getaways, and outstation journeys from Mumbai."
  },
  {
    "name": "Chauffeur Driven 40 Seater Bus",
    "description": "Chauffeur Driven 40 Seater Bus provides a stress-free travel experience with professional drivers handling navigation, traffic, and timing. Fully air-conditioned with comfortable seats and ample luggage space, these buses are suitable for family trips, corporate travel, weddings, school excursions, and leisure tours. Passengers can enjoy a safe, smooth, and convenient journey without worrying about driving or route planning."
  },
  {
    "name": "Best 40 Seater Bus Mumbai",
    "description": "Best 40 Seater Bus Mumbai delivers high-quality, reliable, and comfortable transportation for medium to large groups. Fully air-conditioned with spacious seating and luggage capacity, these buses are perfect for weddings, corporate events, family trips, school excursions, and tourist tours. Professional chauffeurs ensure safe driving, punctual pickups, and smooth travel. Flexible itineraries, multi-stop options, and customizable routes make it ideal for city and outstation travel from Mumbai."
  },
  {
    "name": "Mumbai Bus Booking Service",
    "description": "Mumbai Bus Booking Service enables easy reservation of 40-seater buses for family trips, corporate travel, weddings, school excursions, and group tours. Fully air-conditioned with comfortable seating and luggage storage, these buses ensure a safe, smooth, and convenient journey. Flexible booking options, multi-stop trips, and customizable itineraries make planning medium to large group travel in and around Mumbai simple and efficient."
  },
  {
    "name": "Tourist 40 Seater Bus Mumbai",
    "description": "Tourist 40 Seater Bus Mumbai provides organized and comfortable transport for sightseeing, city tours, heritage visits, and leisure trips for medium to large groups. Fully air-conditioned with spacious seating and luggage space, these buses offer a smooth and relaxing travel experience. Experienced chauffeurs manage traffic, routes, and stops efficiently, allowing passengers to enjoy a stress-free sightseeing journey. Suitable for families, corporate groups, school trips, and friends exploring Mumbai and nearby destinations."
  },
  {
    "name": "Event Bus Rental Mumbai",
    "description": "Event Bus Rental Mumbai offers reliable and comfortable transport for weddings, corporate events, social gatherings, parties, and other special occasions. Fully air-conditioned with spacious seating and luggage space, these buses provide a smooth and enjoyable travel experience. Professional drivers ensure punctual pickups, safe driving, and coordinated multi-stop travel. Ideal for medium to large groups attending events in Mumbai and surrounding areas."
  },
  {
    "name": "Family Trip Bus Mumbai",
    "description": "Family Trip Bus Mumbai is perfect for medium to large family outings, weekend trips, vacation travel, and leisure excursions. Fully air-conditioned 40-seater buses with spacious seating and luggage space provide comfort and convenience. Professional chauffeurs handle traffic, route planning, and timing for a safe, smooth journey. Flexible pickup, drop-off, and multi-stop itineraries make this service ideal for day trips, weekend getaways, and multi-day family travel from Mumbai."
  },
  {
    "name": "Group Travel Bus Mumbai",
    "description": "Group Travel Bus Mumbai specializes in transporting medium to large groups for family outings, corporate trips, school excursions, weddings, and social events. Fully air-conditioned with comfortable seating and ample luggage space, these buses provide a smooth and reliable travel experience. Experienced chauffeurs manage safe driving, routes, and schedules. Flexible pickup, drop-off, and multi-stop itineraries make it convenient for group travel within Mumbai and nearby areas."
  }
],
"tableData": [
  ["40 Seater Bus On Rent in Mumbai", "40 Seater Bus Hire Mumbai"],
  ["AC 40 Seater Bus Mumbai", "Luxury 40 Seater Bus Mumbai"],
  ["Wedding 40 Seater Bus Mumbai", "Corporate 40 Seater Bus Mumbai"],
  ["Outstation 40 Seater Bus Mumbai", "Affordable 40 Seater Bus Mumbai"],
  ["Chauffeur Driven 40 Seater Bus", "Best 40 Seater Bus Mumbai"],
  ["Mumbai Bus Booking Service", "Tourist 40 Seater Bus Mumbai"],
  ["Event Bus Rental Mumbai", "Family Trip Bus Mumbai"],
  ["Group Travel Bus Mumbai", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "40 Seater Bus On Rent in Mumbai with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers 40‑seater buses on rent in Mumbai, ideal for group trips, corporate events, school excursions, weddings, and family outings."
  },
  {
    "WhyChooseheading": "Spacious and Well‑Maintained Buses",
    "WhyChoosedescription": "Travel in clean, air‑conditioned, and regularly serviced 40‑seater buses that ensure a comfortable and enjoyable journey within Mumbai and nearby destinations."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, punctual, and familiar with Mumbai’s routes to provide safe and timely transportation for your group."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for 40‑seater bus rentals, inclusive of fuel, tolls, and driver allowances, with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, itinerary planning, and any last‑minute changes for your bus rental."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from hourly, half‑day, full‑day, or customized rental packages based on your group’s schedule and travel requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All 40‑seater buses are thoroughly cleaned and sanitized before each trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for 40‑seater bus rentals in Mumbai."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide 40‑seater buses on rent in Mumbai?',
    answer: 'Yes, Sanavi Travels offers 40‑seater buses for group trips, corporate events, school excursions, weddings, and family outings in Mumbai.'
  },
  {
    question: 'How can I book a 40‑seater bus in Mumbai?',
    answer: 'You can easily book through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'Are the 40‑seater buses well‑maintained and air‑conditioned?',
    answer: 'Yes, all our 40‑seater buses are clean, air‑conditioned, and regularly serviced for a comfortable travel experience.'
  },
  {
    question: 'Are drivers experienced with Mumbai routes?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with Mumbai’s routes to ensure safe and timely transportation.'
  },
  {
    question: 'Can I rent the 40‑seater bus for a few hours or a full day?',
    answer: 'Absolutely. We offer hourly, half‑day, full‑day, and custom packages to meet your travel needs.'
  },
  {
    question: 'Are the buses sanitized before every trip?',
    answer: 'Yes, all 40‑seater buses are thoroughly cleaned and sanitized before departure.'
  },
  {
    question: 'Is customer support available during the rental?',
    answer: 'Yes, our 24x7 customer support team is available throughout your 40‑seater bus rental.'
  },
  {
    question: 'What payment options are available for 40‑seater bus rentals?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is punctual service guaranteed for 40‑seater bus rentals?',
    answer: 'Yes, Sanavi Travels ensures on‑time pickups and reliable service for all 40‑seater bus bookings in Mumbai.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Amit Sharma',
    feedback: 'Booked a 40‑seater bus in Mumbai for a family outing. Comfortable, clean, and the driver was very professional.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Nisha Rao',
    feedback: 'Excellent 40‑seater bus rental service in Mumbai. Smooth ride, punctual service, and supportive staff.',
    rating: 5
  }
];





































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "40 Seater Bus On Rent in Mumbai - Sanavi Travels",
  "description": "Hire 40 seater buses in Mumbai with Sanavi Travels. AC and luxury buses ideal for weddings, corporate events, outstation trips, family travel, group tours, events, and chauffeur-driven comfortable journeys.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};





  return (
    <div>

<Helmet>
  <title>
    40 Seater Bus On Rent in Mumbai | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book AC and luxury 40 seater buses in Mumbai with Sanavi Travels. Perfect for weddings, corporate events, outstation trips, family travel, group tours, events, and safe chauffeur-driven journeys."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/83.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Fourzerobusonrent;